import React from "react";

import { Navigate, Route, Routes, useNavigate } from "react-router-dom";

import { useEffect } from "react";
import ManageUsers from "../../templates/Admin/Users/ManageUsers";
import Sidebar from "../../templates/Admin/sidebar/Sidebar";
import Navbar from "../../templates/Admin/navbar/Navbar";
import style from "./AdminLayout.module.css";

import Dashboard from "../../templates/Admin/Dashboard/Dashboard";
import { useState } from "react";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import routes from "../../../assets/lang/routes";
import axios from "axios";
import EditUser from "../../templates/Admin/Users/Edit/EditUser";
import AddUser from "../../templates/Admin/Users/Add/AddUser";
import ViewUser from "../../templates/Admin/Users/View/ViewUser";

export default function AdminLayout() {
  const Navigator = useNavigate();

  useEffect(() => {
    async function checkUserIsAdmin() {
      try {
        const res = await axios.get("/isAdmin");
        if (res.data.status === 200 && res.data.role === 1) {
          localStorage.setItem("role", "admin");
        } else {
          Navigator("/editor");
        }
      } catch (error) {
        console.log(error);
      }
    }
    checkUserIsAdmin();
  }, []);

  const [toggleSiebar, setToggleSiebar] = useState(false);

  const sidebarToggle = () => {
    toggleSiebar ? setToggleSiebar(false) : setToggleSiebar(true);
  };

  return (
    <div className={`${style.adminLayout}`}>
      <Navbar />

      <div className={`${style.mainLayout}`}>
        <div
          className={`${style.sidebar} ${
            toggleSiebar ? `${style.collapsed}` : ""
          } `}
        >
          {/* toggle */}
          <div
            className={`${style.mySignatureToggle} ${
              toggleSiebar ? `${style.collapsed}` : ""
            }`}
            onClick={sidebarToggle}
          >
            <FontAwesomeIcon icon={toggleSiebar ? faAngleRight : faAngleLeft} />
          </div>
          {/* toggle */}
          <Sidebar isToggled={toggleSiebar} />
        </div>

        <div
          className={` ${style.mainContent}  ${
            toggleSiebar ? `${style.collapsed}` : ""
          }`}
        >
          <Routes>
            <Route path="/users" element={<ManageUsers />} />
            <Route path="/user/edit/*" element={<EditUser />} />
            <Route path="/user/view/*" element={<ViewUser />} />
            <Route path="/user/add" element={<AddUser />} />

            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/*" element={<Navigate to="dashboard" />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}
